import moment from 'moment-timezone';

const GetLocalTimefromUTC = (timeString) => {
  let utcTime = new Date(timeString);
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const localTime = utcTime.toLocaleString(undefined, { timeZone: clientTimeZone });
  return new Date(localTime);
};

const GetTimeZoneList = () => {
  const timeZones = moment.tz.names();
  // Map to array with offset and sort by offset descending
  return timeZones
    .map(timeZone => {
      const offsetMinutes = moment.tz(timeZone).utcOffset();
      const offset = moment.tz(timeZone).format('Z');
      return { timeZone, offset, offsetMinutes };
    })
    .sort((a, b) => b.offsetMinutes - a.offsetMinutes)
    .map(({ timeZone, offset }) => ({ timeZone, offset }));
}

export const TimeHelper = {
  GetLocalTimefromUTC,
  GetTimeZoneList
}